jQuery(function ($) {
	$(document).ready(function () {
		$('#myCarousel').carousel({
			interval: 10000
		});
		$('.item').addClass('animated fadeOut');
		$('.item').hover(function () {
			$(this).toggleClass('animated fadeOut');
		});
		$('.carousel-indicators a').click(function(e) {
			e.preventDefault();
		})
	    //Enable swiping...
		$(".carousel-inner").swipe({
		    //Generic swipe handler for all directions
		    swipeLeft: function () {
		        $(this).parent().carousel('prev');
		    },
		    swipeRight: function () {
		        $(this).parent().carousel('next');
		    },
		    //Default is 75px, set to 0 for demo so any distance triggers swipe
		    threshold: 0
		});
	});
});


// WEBPACK FOOTER //
// ./scripts/old/carousel.js